import { defineCustomElement } from '../chunks/vidstack-BGSTndAW.js';
import { MediaPlayButtonElement, MediaMuteButtonElement, MediaCaptionButtonElement, MediaPIPButtonElement, MediaFullscreenButtonElement, MediaSeekButtonElement, MediaAirPlayButtonElement, MediaLiveButtonElement, MediaVolumeSliderElement, MediaTimeSliderElement, MediaSliderPreviewElement, MediaSliderThumbnailElement, MediaSliderValueElement, MediaMenuElement, MediaMenuButtonElement, MediaMenuItemsElement, MediaMenuItemElement, MediaAudioRadioGroupElement, MediaCaptionsRadioGroupElement, MediaSpeedRadioGroupElement, MediaQualityRadioGroupElement, MediaRadioElement, MediaTimeElement, MediaThumbnailElement } from '../chunks/vidstack-K_Jbv5ge.js';
import { MediaPlyrLayoutElement } from './templates/plyr-layout.js';
import { MediaPosterElement } from '../chunks/vidstack-D3ltXc3a.js';
import '../chunks/vidstack-B5rN6wRF.js';
import '../chunks/vidstack-DJDnh4xT.js';
import '../chunks/vidstack-C2US-gSO.js';
import '@floating-ui/dom';
import '../chunks/vidstack-Ci54COQW.js';
import '../chunks/vidstack-CTojmhKq.js';
import '../chunks/vidstack-xMS8dnYq.js';
import '../chunks/vidstack-DYbwIVLq.js';
import '../chunks/vidstack-DsPOyKtl.js';
import '../chunks/vidstack-Dihypf8P.js';
import '../chunks/vidstack-C9vIqaYT.js';
import '../chunks/vidstack-BTM4ERc7.js';
import 'lit-html';
import '../chunks/vidstack-BCNJm_N2.js';
import '../chunks/vidstack-Dq5Yu0Vr.js';
import 'lit-html/directives/if-defined.js';
import 'lit-html/directives/unsafe-svg.js';
import 'lit-html/async-directive.js';
import '../chunks/vidstack-CwTj4H1w.js';
import 'lit-html/directives/unsafe-html.js';
import '../chunks/vidstack-BiyXcJ_M.js';

defineCustomElement(MediaPlyrLayoutElement);
defineCustomElement(MediaPosterElement);
defineCustomElement(MediaPlayButtonElement);
defineCustomElement(MediaMuteButtonElement);
defineCustomElement(MediaCaptionButtonElement);
defineCustomElement(MediaPIPButtonElement);
defineCustomElement(MediaFullscreenButtonElement);
defineCustomElement(MediaSeekButtonElement);
defineCustomElement(MediaAirPlayButtonElement);
defineCustomElement(MediaLiveButtonElement);
defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderThumbnailElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuItemsElement);
defineCustomElement(MediaMenuItemElement);
defineCustomElement(MediaAudioRadioGroupElement);
defineCustomElement(MediaCaptionsRadioGroupElement);
defineCustomElement(MediaSpeedRadioGroupElement);
defineCustomElement(MediaQualityRadioGroupElement);
defineCustomElement(MediaRadioElement);
defineCustomElement(MediaTimeElement);
defineCustomElement(MediaThumbnailElement);
